import { Mail, MessageCircle } from "lucide-react";
import { useSiteBranding } from "@/context/SiteContext";

const simulatedLeadRows = (listings = []) => {
  const seeds = listings.slice(0, 3);
  return seeds.map((listing, index) => ({
    id: `${listing.id}-${index}`,
    name: ["Akshaya Priority Investor", "Memo Request Watchlist", "Warm WhatsApp Follow-up"][index] || "Launch Queue Prospect",
    focus: listing.title,
    status: ["HOT", "WARM", "NEW"][index] || "NEW",
    score: [92, 76, 61][index] || 55,
  }));
};

export const AmbassadorLeadCommandCenter = ({ listings = [] }) => {
  const { branding, getWhatsAppHref } = useSiteBranding();
  const rows = simulatedLeadRows(listings);

  return (
    <div className="rounded-[32px] border border-[#D4AF37]/18 bg-[linear-gradient(160deg,#171717_0%,#1A1A1A_54%,#22201C_100%)] p-6 text-[#F6F1E9] shadow-[0_24px_70px_rgba(22,18,11,0.24)]" data-testid="ambassador-lead-command-center">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#D4AF37]">Simulated Lead Command Center</p>
          <h2 className="mt-3 font-[Cormorant_Garamond,serif] text-4xl font-bold leading-none">Launch-day queue preview for this Ambassador cockpit.</h2>
        </div>
        <p className="rounded-full border border-[#D4AF37]/25 bg-white/5 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]" data-testid="ambassador-lead-command-center-simulated-pill">
          Simulation layer
        </p>
      </div>

      <div className="mt-6 grid gap-4 lg:grid-cols-3">
        <div className="rounded-[24px] border border-[#D4AF37]/14 bg-[#252525] p-5" data-testid="ambassador-lead-command-center-total-card">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]">Queued prospects</p>
          <p className="mt-3 text-3xl font-semibold">{rows.length ? rows.length + 6 : 6}</p>
        </div>
        <div className="rounded-[24px] border border-[#D4AF37]/14 bg-[#252525] p-5" data-testid="ambassador-lead-command-center-hot-card">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]">HOT tier</p>
          <p className="mt-3 text-3xl font-semibold">{rows.length ? 2 : 1}</p>
        </div>
        <div className="rounded-[24px] border border-[#D4AF37]/14 bg-[#252525] p-5" data-testid="ambassador-lead-command-center-response-card">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]">Expected SLA</p>
          <p className="mt-3 text-3xl font-semibold">4 min</p>
        </div>
      </div>

      <div className="mt-6 grid gap-4">
        {rows.map((row) => (
          <div className="flex flex-wrap items-center justify-between gap-4 rounded-[24px] border border-[#D4AF37]/14 bg-[#242424] px-5 py-4" data-testid={`ambassador-simulated-lead-row-${row.id}`} key={row.id}>
            <div className="min-w-0">
              <p className="text-lg font-semibold">{row.name}</p>
              <p className="mt-1 text-sm text-[#F6F1E9]/74">Focused on {row.focus}</p>
            </div>
            <div className="flex flex-col items-stretch gap-3 sm:items-end">
              <div className="flex items-center gap-3">
                <span className="rounded-full border border-[#D4AF37]/25 bg-[#D4AF37]/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]">{row.status}</span>
                <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-[#B8B0A5]">{row.score}/100</span>
              </div>
              <div className="flex flex-wrap gap-2" data-testid={`ambassador-simulated-lead-actions-${row.id}`}>
                <a className="inline-flex items-center justify-center gap-2 rounded-full border border-[#D4AF37]/24 bg-[#D4AF37] px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-[#1A1A1A]" data-testid={`ambassador-simulated-lead-whatsapp-${row.id}`} href={getWhatsAppHref(`Hello ${branding.name || "team"}, I want a quick update on ${row.focus}.`)} rel="noreferrer" target="_blank">
                  <MessageCircle className="h-3.5 w-3.5" /> Quick-Action WhatsApp
                </a>
                <a className="inline-flex items-center justify-center gap-2 rounded-full border border-white/12 bg-white/6 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-[#F6F1E9]" data-testid={`ambassador-simulated-lead-email-${row.id}`} href={`mailto:${branding.email}?subject=${encodeURIComponent(`Lead follow-up: ${row.focus}`)}`}>
                  <Mail className="h-3.5 w-3.5" /> Email Agent
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};